import React from "react";
import TrackedTableHead from "./TrackedTableHead/TrackedTableHead";
import TrackedTableBody from "./TrackedTableBody/TrackedTableBody";

export default function TrackedTable() {
	return (
		<>
			<TrackedTableHead />
			<div className="tracked-table-body ">
				<TrackedTableBody />
			</div>
		</>
	);
}
